import React from "react";
import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { formatINR } from "../lib/api";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useShop();

  if (wishlist.length === 0) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="wishlist-empty">
        <Heart size={40} strokeWidth={1.2} className="mx-auto text-brand-maroon" />
        <h1 className="font-serif-brand text-4xl text-brand-charcoal mt-6">Your wishlist is empty</h1>
        <p className="text-brand-muted mt-2">Tap the heart on any piece to save it for later.</p>
        <Link to="/shop" className="btn-primary inline-block mt-8">Browse Jewellery</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="wishlist-page">
      <p className="label-tiny text-brand-gold">Saved for later</p>
      <h1 className="font-serif-brand text-4xl lg:text-5xl text-brand-charcoal mt-2 mb-10">Your Wishlist · {wishlist.length}</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 lg:gap-x-8 gap-y-10">
        {wishlist.map((w) => (
          <div key={w.id} className="relative group" data-testid={`wishlist-item-${w.slug}`}>
            <Link to={`/product/${w.slug}`} className="block aspect-[4/5] overflow-hidden bg-brand-ivory-soft">
              <img src={w.image} alt={w.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </Link>
            <button onClick={() => toggleWishlist({ id: w.id })} className="absolute top-3 right-3 w-8 h-8 bg-brand-ivory/80 backdrop-blur-md flex items-center justify-center hover:bg-brand-maroon hover:text-brand-ivory transition-colors duration-200" aria-label="Remove">
              <X size={14} strokeWidth={1.5} />
            </button>
            <Link to={`/product/${w.slug}`} className="block mt-3 font-serif-brand text-lg text-brand-charcoal hover:text-brand-maroon">{w.name}</Link>
            <p className="text-brand-maroon font-semibold mt-1">{formatINR(w.price)}</p>
            <button onClick={() => addToCart({ id: w.id, slug: w.slug, name: w.name, price: w.price, images: [w.image] })} className="w-full mt-3 text-xs tracking-[0.2em] uppercase font-medium py-2.5 border border-brand-charcoal/70 hover:bg-brand-maroon hover:border-brand-maroon hover:text-brand-ivory transition-colors duration-300">Add to Cart</button>
          </div>
        ))}
      </div>
    </div>
  );
}
